import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "weChatConvListContainer" }
const _hoisted_2 = { class: "weChatConvList" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { computed, onMounted } from "vue";
import { WeChatActions, WeChatGetters, WeChatMutations } from "@/store/modules/weChat";
import { WeChatContact } from "@/store/modules/weChat/types";
import WeChatSessionCard from "@/components/weChat/WeChatSessionCard.vue";
import WeChatSearch from '@/components/weChat/WeChatSearh.vue';


import { defineComponent } from "vue";

const __default__ = defineComponent({
    name: "WeChatConvWindow",
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const store = useStore();
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const wechatIdCom = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getMeId}`];
});
const meIdIsLoading = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getIsMeLoading}`];
});

const isSessionAllLoaded = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getIsSessionAllLoaded}`];
}
);
const isSessionLoading = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getIsSessionLoading}`];
});
const sessionList = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getWeChatSessionList}`];
});
const selectedSession = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getSelectedSession}`];
});
const loadWeChatSession = async () => {
    if (wechatIdCom.value !== '' && !isSessionAllLoaded.value && !isSessionLoading.value) {
        const projId = projectId.value;
        const uid = targetId.value;
        const wechatId = wechatIdCom.value;
        const isAppend = true;
        try {
            await store.dispatch(`weChat/${WeChatActions.asyncGetSessionListByUid}`, { projId, uid, wechatId, isAppend });
        } catch (err) {
            console.log(err);
        }
    }
}

const isSessionSelected = (strUsrName: string) => {
    if (!selectedSession.value) {
        return false;
    }
    return strUsrName === selectedSession.value.strUsrName;
}

const handleClick = (session: WeChatContact) => {
    store.commit(`weChat/${WeChatMutations.setSelectedSession}`, session);
}

const asyncGetWeChatIdList = async () => {
    let projid = projectId.value
    let uid = targetId.value
    await store.dispatch(`weChat/${WeChatActions.asyncGetMeId}`, { projid, uid });
}



onMounted(async () => {
    try {
        asyncGetWeChatIdList()
        if (wechatIdCom.value !== '') {
            await loadWeChatSession()
        }
    } catch (err) {
        console.log(err);
    }
});


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sessionList), (session) => {
        return (_openBlock(), _createElementBlock("div", {
          key: session.strUsrName
        }, [
          _createElementVNode("div", {
            class: _normalizeClass({ 'weChatConv': true, 'weChatConvActive': isSessionSelected(session.strUsrName) }),
            onClick: ($event: any) => (handleClick(session))
          }, [
            _createElementVNode("div", null, [
              _createVNode(WeChatSessionCard, {
                msgSender: session.strNickName,
                msgContent: session.strContent,
                target: ''
              }, null, 8, ["msgSender", "msgContent"])
            ])
          ], 10, _hoisted_3)
        ]))
      }), 128)),
      (_unref(isSessionLoading))
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, "加载中......"))
        : _createCommentVNode("", true),
      (_unref(isSessionAllLoaded))
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, "------已加载全部-------"))
        : _createCommentVNode("", true)
    ])), [
      [_directive_loading, _unref(meIdIsLoading)],
      [_directive_infinite_scroll, loadWeChatSession]
    ])
  ]))
}
}

})